<div class="main-wrapper">
  <div class="ts-header">
    <div class="header-bottom hidden-phone container-fluid py-3">
      <div class="container-fluid px-0">
        <div class="menu-wrapper">

          <div class="ts-menu" *ngIf="headerCategoryList?.length === 0">
            <nav class="main-menu pc-menu ts-mega-menu-wrapper">
              <ul id="menu-main-menu" class="menu">
                <li id="menu-item-1133"
                  class="font-body menu-item menu-item-type-post_type menu-item-object-page menu-item-1133 ts-normal-menu">
                  <a [routerLink]="['/shop/product-list']"><span class="menu-label">{{ 'menu.label.grocery' |
                      translate}}</span></a>
                </li>
                <li id="menu-item-1134"
                  class="font-body menu-item menu-item-type-post_type menu-item-object-page menu-item-1134 ts-normal-menu">
                  <a [routerLink]="['/shop/product-list']"><span class="menu-label">{{ 'menu.label.freshfoods' |
                      translate}}</span></a>
                </li>
                <li id="menu-item-1133"
                  class="font-body menu-item menu-item-type-post_type menu-item-object-page menu-item-1133 ts-normal-menu">
                  <a [routerLink]="['/shop/store-finder']"><span class="menu-label">{{ 'menu.label.fashion' |
                      translate}}</span></a>
                </li>
                <li id="menu-item-1134"
                  class="font-body menu-item menu-item-type-post_type menu-item-object-page menu-item-1134 ts-normal-menu">
                  <a [routerLink]="['/shop/product-list']"><span class="menu-label">{{ 'menu.label.foodtogo' |
                      translate}}</span></a>
                </li>
                <li id="menu-item-1133"
                  class="font-body menu-item menu-item-type-post_type menu-item-object-page menu-item-1133 ts-normal-menu">
                  <a [routerLink]="['/pages/credits-and-coupons']" (click)="validateUser();"><span class="menu-label">{{
                      'menu.label.deals' | translate}}</span></a>
                </li>
                <li id="menu-item-1134"
                  class="font-body menu-item menu-item-type-post_type menu-item-object-page menu-item-1134 ts-normal-menu">
                  <a [routerLink]="['/shop/aboutmegamart']"><span class="menu-label">{{ 'menu.label.aboutus' |
                      translate}}</span></a>
                </li>
              </ul>
            </nav>
          </div>
          <!-- Dynamic Header Menu category List-->
          <div class="ts-menu menuallign" *ngIf="headerCategoryList?.length >= 2">
            <nav class="main-menu pc-menu ts-mega-menu-wrapper cat index">
              <ul id="menu-main-menu" class="menu" *ngFor="let category of headerCategoryList; index as i">                
                <li id="menu-item-1133" *ngIf="(i < 4) && category.category_image_url != ''"
                  class="font-body menu-item menu-item-type-post_type menu-item-object-page menu-item-1133 ts-normal-menu">
                  <a (click)="navigateCategoryList(category);"><span class="menu-label">{{category.category_name}}
                      </span></a>
                </li>
                <li id="menu-item-11331" *ngIf="(i === headerCategoryList.length - 3)"
                  class="font-body menu-item menu-item-type-post_type menu-item-object-page menu-item-1133 ts-normal-menu">
                  <a [routerLink]="['/pages/credits-and-coupons']" (click)="validateUser();"><span class="menu-label">{{
                      'menu.label.deals' | translate}}</span></a>
                </li>                
                <li id="menu-item-11341" *ngIf="(i === headerCategoryList.length - 2)"
                  class="font-body menu-item menu-item-type-post_type menu-item-object-page menu-item-1134 ts-normal-menu">
                  <a [routerLink]="['/shop/aboutmegamart']"><span class="menu-label">{{ 'menu.label.aboutus' |
                      translate}}</span></a>
                </li>
                <li id="menu-item-11331" *ngIf="(i === headerCategoryList.length - 1)"
                  class="font-body menu-item menu-item-type-post_type menu-item-object-page menu-item-1133 ts-normal-menu">
                  <a [routerLink]="['/shop/store-finder']"><span class="menu-label">{{
                      'menu.label.storefinder' | translate}}</span></a>
                </li>
              </ul>
            </nav>
          </div>

        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid pt-2">
    <!-- Home slider start-->
    <app-slider [sliders]="sliders" [buttonText]="'Shop now'">
    </app-slider>
    <!-- Home slider End -->
    <br>
    <!-- Ads container banner -->
    <section class="pb-30">
      <app-ads-container [adslist]="collections">
      </app-ads-container>
    </section>
    <!-- collection banner end -->

    <!-- product section start-->
    <section class="pb-30" *ngIf="products?.length > 0">
      <app-multi-item-slider [products]="products" [ProductSliderConfig]="ProductSliderConfig"
        [sliderDetails]="offerSliderDetails" [targetUrl]="'shop/productlist/weeklyoffer'"></app-multi-item-slider>
    </section>
    <!-- product section end -->

    <!-- categories menu start-->
    <section class="pb-30" *ngIf="categories?.length > 0">
      <app-category [categories]="categories"></app-category>
    </section>


    <!-- More deals section -->
    <section class="pb-30">
      <div class="header">
        <h1 class="title pb-27 mb-0" *ngIf="dealslist?.length > 0">{{ 'common.label.moredealsforyou' | translate}}</h1>
      </div>

      <app-ads-container [adslist]="dealslist">
      </app-ads-container>
    </section>
    <!-- More deals section end-->


    <!-- Brands section start-->
    <section class="pb-55" *ngIf="brands?.length > 0">
      <!-- <a  (click)="navigateBrandProductList(brands?.manufacturer_id)"> -->
      <app-brand-slider [brands]="brands" [brandSliderConfig]="brandSliderConfig"
        [sliderDetails]="branditemsSliderDetails"></app-brand-slider>
      <!-- Brands section end-->
      <!-- </a> -->
    </section>

    <section *ngFor="let category of topCategories" class="pb-55">
      <app-category-widget *ngIf="category?.products?.records && category?.products?.records?.length > 0"
        [categoryDetails]="category"></app-category-widget>
    </section>

    <section class="pb-30" *ngIf="purchaseditems?.length > 6">
      <app-multi-item-slider [products]="purchaseditems" [ProductSliderConfig]="PurchasedItemsConfig"
        [sliderDetails]="purchaseditemsSliderDetails" [targetUrl]="'shop/productlist/recently-purchased-items'"></app-multi-item-slider>
    </section>
  </div>
</div>